import { toast } from 'sonner'
import { useState, useEffect } from 'react'
import { fError } from '@/utils/format-error'
import axios, { endpoints } from '@/lib/axios'
import { useBoolean } from '@/hooks/use-boolean'
import { useParams } from '@/routes/hooks/use-params'
import LoadingSection from '@/components/loading-indicator/loading-section'

import type { Program } from '../program.types'

import ProgramManage from '../program-manage'

export default function ProgramManageView() {
  const params = useParams()
  const loading = useBoolean(true)
  const [program, setProgram] = useState<Program | undefined>(undefined)

  const isEditMode = params.id !== undefined

  const fetchProgram = async () => {
    if (!isEditMode || !params.id) {
      loading.onFalse()
      return
    }

    try {
      loading.onTrue()

      // Fetch program details
      const programResponse = await axios.get<Program>(
        endpoints.programs.detail(params.id),
      )
      setProgram(programResponse.data)
    } catch (error) {
      console.error(error)
      toast.error(fError(error))
    } finally {
      loading.onFalse()
    }
  }

  useEffect(() => {
    fetchProgram()
  }, [params.id])

  const handleProgramUpdate = (updatedProgram: Program) => {
    setProgram(updatedProgram)
  }

  return (
    <LoadingSection loading={loading.value}>
      <ProgramManage program={program} onProgramUpdate={handleProgramUpdate} />
    </LoadingSection>
  )
}
